/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Meeting_Sources_Previous_Meta_ManyInputs */



/**
* | output |
* | --- |
* | "latest of {count} reports" |
*
* @param {Meeting_Sources_Previous_Meta_ManyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_previous_meta_many = /** @type {((inputs: Meeting_Sources_Previous_Meta_ManyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_Previous_Meta_ManyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`laatste van ${i?.count} verslagen`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`dernier de ${i?.count} comptes rendus`)
	return /** @type {LocalizedString} */ (`latest of ${i?.count} reports`)
});